// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"pXZXY","between":"gCNIN","select":"_9tves","label":"URqNF"};